const urlParams = new URLSearchParams(window.location.search);
const discount = urlParams.get('code');
let variant = urlParams.get('variant');
if (!variant || !/^\d+$/.test(variant)) {
  variant = '45422799650860';
}
const variantId = Number(variant);

const checkbox = document.getElementById('agree-checkbox');
const button = document.getElementById('continue-btn');

let isSubmitting = false;

if (!variant || isNaN(variantId) || variantId <= 0) {
  button.disabled = true;
  button.textContent = 'Invalid offer link';
  console.error('Invalid or missing variant ID:', variant);
} else {
  checkbox.addEventListener('change', () => {
    const checked = checkbox.checked;
    button.disabled = !checked;
    button.style.cursor = checked ? 'pointer' : 'not-allowed';
    button.style.opacity = checked ? '1' : '0.5';
  });

  button.addEventListener('click', () => {
    if (button.disabled || isSubmitting) return;
    isSubmitting = true;
    button.disabled = true;
    button.textContent = 'Loading...';

    const checkoutUrl = discount
      ? `/cart/${variantId}:1?discount=${encodeURIComponent(discount)}`
      : `/cart/${variantId}:1`;

    window.location.assign(checkoutUrl);
  });
}